import React, { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import SolutionNav from '../NavContainer/SolutionNav';
import ProductionNav from '../NavContainer/ProductionNav';
import ResourceNav from '../NavContainer/ResourceNav';
import AboutNav from '../NavContainer/AboutNav';
import NewsNav from '../NavContainer/NewsNav';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NAV_CATEGORY } from 'layouts/Main/constants';
import isEmpty from 'lodash/isEmpty';

interface Props {
  title: string;
  id: string;
  type?: number;
  items: Array<PageItem>;
  colorInvert?: boolean;
  showPanel?: boolean;
}

const NavItem = ({
  title,
  id,
  items,
  type,
  colorInvert = false,
  showPanel,
}: Props): JSX.Element => {
  const t = useTranslations('Home.nextNav');
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openedPopoverId, setOpenedPopoverId] = useState(null);

  const handleClick = (event, popoverId) => {
    setAnchorEl(event.target);
    setOpenedPopoverId(popoverId);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
    setOpenedPopoverId(null);
  };

  const [activeLink, setActiveLink] = useState('');
  useEffect(() => {
    setActiveLink(window && window.location ? window.location.pathname : '');
  }, []);

  const hasActiveLink = () =>
    items.find((i) => activeLink && activeLink.includes(i.href));
  const linkColor = colorInvert ? 'common.white' : 'text.primary';

  return (
    <Box>
      {showPanel === false ? (
        <Box
          display={'flex'}
          alignItems={'center'}
          aria-describedby={id}
          sx={{
            cursor: 'pointer',
          }}
          onClick={(e) => {
            console.log('items', items);
            if (!isEmpty(items)) {
              window.location.href = items[0].href;
            }
          }}
        >
          <Typography
            fontWeight={openedPopoverId === id || hasActiveLink() ? 700 : 400}
            color={linkColor}
            fontSize={'14px'}
            // sx={{
            //   fontSize: '1rem',
            //   transition: 'font-size 0.3s ease-in-out',
            //   '&:hover': {
            //     fontSize: '1.2rem',
            //   },
            //   '&:active': {
            //     fontSize: '1.2rem',
            //   },
            // }}
          >
            {title}
          </Typography>
        </Box>
      ) : (
        <Box
          display={'flex'}
          alignItems={'center'}
          aria-describedby={id}
          sx={{ cursor: 'pointer' }}
          onClick={(e) => handleClick(e, id)}
        >
          <Typography
            fontWeight={openedPopoverId === id || hasActiveLink() ? 700 : 400}
            color={linkColor}
            fontSize={'14px'}
          >
            {title}
          </Typography>
          <ExpandMoreIcon
            sx={{
              marginLeft: theme.spacing(1 / 4),
              width: 16,
              height: 16,
              transform: openedPopoverId === id ? 'rotate(180deg)' : 'none',
              color: linkColor,
            }}
          />
        </Box>
      )}
      <Popover
        elevation={3}
        id={id}
        open={openedPopoverId === id}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '.MuiPaper-root': {
            // maxWidth: items.length > 12 ? 350 : 250,
            maxWidth: 1000,
            padding: 2,
            marginTop: 2,
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            borderBottomRightRadius: 8,
            borderBottomLeftRadius: 8,
            borderTop: `3px solid ${theme.palette.primary.main}`,
          },
        }}
      >
        {type === NAV_CATEGORY.Production.value && (
          <ProductionNav activeLink={activeLink} />
        )}
        {type === NAV_CATEGORY.Solution.value && (
          <SolutionNav activeLink={activeLink} />
        )}
        {type === NAV_CATEGORY.Resource.value && (
          <ResourceNav activeLink={activeLink} />
        )}
        {type === NAV_CATEGORY.News.value && (
          <NewsNav activeLink={activeLink} />
        )}
        {type === NAV_CATEGORY.About.value && (
          <AboutNav activeLink={activeLink} />
        )}
      </Popover>
    </Box>
  );
};

export default NavItem;
